import { ICON } from "./Icons/Icons";

export const toggleSwitch = (id) => {
    return `
    <div class='toggleSwitch'>
        <input type='checkbox' id='${id}'/>
        <label for='${id}'>
            <div class="switch"></div>
        </label>
    </div>`;
}

export const indicator2D = (id, cls, icon, title, dataLang) => {
    const domIcon = icon === 'chess' ? `<i class="fas fa-chess"></i>` : `<span class='material-icons-outlined'>${icon}</span>`;
    return `
    <div class='indicator ${cls} indicator-${id}' data-indicator='${id}'>
        <div class='circle-wrapper'>
            ${domIcon}
        </div>
        <div class='helper-icon payment'>
            <span class='material-icons-outlined'>paid</span>
        </div>
        ${icon === 'chess' ? `
        <div class='helper-icon locked'>
            ${ICON.LOCK}
        </div>
        <div class='helper-icon playing'>
            ${ICON.GAMEPAD}
        </div>
        <div class='helper-icon watching'>
            ${ICON.EYE}
        </div>
            <div class='people-wrapper'>
                <div class='people-wrapper-inner'>
                    <div class='world-bottom-nav__area__item world-bottom-nav__area__people' id='chess-people-indicator-${id}'>
                        ${ICON.PEOPLE}
                        <div class="world-bottom-nav__area__people__count">2</div>
                    </div>
                </div>
            </div>
            <div class='helper-icon user-1'>
                <img src='' alt='user' />
            </div>
            <div class='helper-icon user-2'>
                <img src='' alt='user' />
            </div>
        ` : ''}
        <span class='tooltip' data-lang='${dataLang}'>${title}</span>
    </div>`;
}

export const group_btn = (id, title, icon, cls = '', options = {}) => {
    const chkcls = cls === 'single' ? 'selected_elements' : 'group_checkbox';
    const showVisibilityControl = options.showVisibilityControl !== false;
    const isVisible = options.groupVisible !== false;
    return `
    <div class="group-btn ${cls}" data-id='${id}'>
        <div class="elements-checkbox-holder">
            <span class='material-icons-outlined box_uncheck group-icon'>${icon}</span>
            <div class='customCheckbox'>
                <input type='checkbox' id='element_${id}' class='${chkcls}' data-id='${id}'/>
                <label for='element_${id}'>
                    <span class='material-icons-outlined box_uncheck'>check_box_outline_blank</span>
                    <span class='material-icons box_check'>check_box</span>
                </label>
            </div>
        </div>
        <span class="group-title">${title}</span>
        ${showVisibilityControl ? `<span class="material-icons-outlined group-visibility-control ${isVisible ? 'enabled' : ''}" data-action="group-visibility" title="${isVisible ? 'Hide group' : 'Show group'}">${isVisible ? 'visibility' : 'visibility_off'}</span>` : ''}
        <span class='material-icons-outlined chevron'>expand_more</span>
        <span class='material-icons-outlined delete-element' data-id="${id}">delete</span>
    </div>
    `;
}

export const group_element = (id, title, options = {}) => {
    const locked = !!options.locked;
    const visible = options.visible !== false;
    const showDelete = options.showDelete !== false;
    return `
    <li class="group-element" data-id='${id}'>
        <div class='customCheckbox'>
            <input type='checkbox' class="selected_elements" id='element_${id}' data-id="${id}"/>
            <label for='element_${id}'>
                <span class='material-icons-outlined box_uncheck'>check_box_outline_blank</span>
                <span class='material-icons box_check'>check_box</span>
            </label>
        </div>
        <span class="material-icons-outlined group-element-control group-element-lock ${locked ? 'enabled' : ''}" data-action="lock" title="${locked ? 'Unlock element' : 'Lock element'}">${locked ? 'lock' : 'lock_open'}</span>
        <span class="material-icons-outlined group-element-control group-element-visibility ${visible ? 'enabled' : ''}" data-action="visibility" title="${visible ? 'Hide element' : 'Show element'}">${visible ? 'visibility' : 'visibility_off'}</span>
        <span class="element-title">${title}</span>
        ${showDelete ? `<span class='material-icons-outlined delete-element' data-id="${id}">delete</span>` : ''}
    </li>
    `;
}
export const custom_checkbox = (id, clas) => {
    clas = clas || "selected_elements";
    return `
        <div class='customCheckbox'>
            <input type='checkbox' class="${clas}" id='element_${id}' data-id="${id}"/>
            <label for='element_${id}'>
                <span class='material-icons-outlined box_uncheck'>check_box_outline_blank</span>
                <span class='material-icons box_check'>check_box</span>
            </label>
        </div>
    `;
}
export const chess_game_dark = (id, lng) => `
<div class="modal chess-game chess-game-special-landscape-mode" id="chess-game_${id}">
    <div class="chess-history-wrapper"></div>
    <div class="modal-background"></div>
    <div class="modal-card">
        <div class="chess-container">
            <div class="chess-players">
                <div class="chess-player-top" id="chess-player-one_${id}" data-chess-player="player1">
                    <div class="chess-avatar-wrapper-one" id="chess-avatar-wrapper-one">
                    </div>
                </div>
                <div class="chess-player-bottom" id="chess-player-two_${id}" data-chess-player="player2">
                    <div class="chess-avatar-wrapper-two" id="chess-avatar-wrapper-two">
                    </div>
                </div>
            </div>
      
            <div class="chess-game">
                <div class="chess-game-container" id="chess-game-container_${id}"></div>
            </div>

            <div class="chess-watchers" id="chess-visitors-container_${id}">
                <div id="chess-visitors-avatars_${id}" class="chess-watchers-grid">
                    <div class="spectators-info-title">
                        <p data-lang="take_a_seat_to_talk_with_others">Take a seat to talk with others</p>
                    </div>
                    <div id="player-indicator-visitor-1" class="player-indicator-visitor"></div>
                    <div id="player-indicator-visitor-2" class="player-indicator-visitor"></div>
                    <div id="player-indicator-visitor-3" class="player-indicator-visitor"></div>
                    <div id="player-indicator-visitor-4" class="player-indicator-visitor"></div>
                    <div id="player-indicator-visitor-5" class="player-indicator-visitor"></div>
                    <div id="player-indicator-visitor-6" class="player-indicator-visitor"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal chess-win-modal" id="modal-winner_${id}">
    <div class="modal-background"></div>
    <div class="modal-card chess-win-modal__modal-card">
        <section class="chess-win-modal__content">
            <div id="winner-msg_${id}"></div>
            <img id="winner-image_${id}" src="./textures/victory.jpg" alt="Victory" class="modal-winner-image">
        </section>
        <section class="close_winner_modal chess-win-modal__actions">
          <div class="buttn primary chess-win-modal__button" id="close-winner-modal_${id}">OK</div>
          <div class="buttn primary chess-win-modal__button" id="winner-modal-restart_${id}">Restart</div>
        </section>
    </div>
</div>
`;
